var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg78(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h900v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M241.47 207.347c48.868-61.302 152.713-86.949 222.135 4.946 58.886 77.944 84.54 82.404 129.298 97.232 29.553 9.797 77.912 23.07 49.732 98.885-36.882 99.228-219.34 126.031-319.103 88.992-95.403-35.415-170.751-178.815-82.062-290.055z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M451.447 166.217c22.905 40.196 66.285 91.964 138.509 112.966 72.223 20.99 85.086-21.998 63.315-71.971-21.77-49.973-75.192-93.968-141.477-103.965-66.285-9.997-79.148 29.979-60.347 62.97z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M747 198.463v226.279c0 16.531-13.4 29.9-29.925 29.9h-533.59c-16.526 0-29.925-13.369-29.925-29.9V198.463c0-16.535 13.403-29.944 29.925-29.944h533.59c16.522 0 29.925 13.409 29.925 29.944z",
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M358.471 433.496H201.285c-11.9 0-21.58-9.686-21.58-21.593v-157.28c0-11.907 9.68-21.592 21.58-21.592h157.186c11.9 0 21.58 9.685 21.58 21.592v157.28c0 11.952-9.68 21.593-21.58 21.593z",
    fill: "#666AF6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M544.259 257.954H405.811a6.843 6.843 0 0 1 0-13.684h138.448a6.843 6.843 0 0 1 6.838 6.842c-.044 3.777-3.063 6.842-6.838 6.842zm-63.096 27.235h-75.352a6.843 6.843 0 0 1 0-13.684h75.352a6.843 6.843 0 0 1 6.838 6.842c-.045 3.777-3.064 6.842-6.838 6.842zm231.651 0H508.916a6.842 6.842 0 0 1 0-13.684h203.898a6.843 6.843 0 0 1 6.838 6.842c-.045 3.777-3.064 6.842-6.838 6.842zm-190.401 27.235H405.811a6.843 6.843 0 0 1 0-13.684h116.602a6.843 6.843 0 0 1 6.838 6.842c-.044 3.776-3.108 6.842-6.838 6.842zm98.929 0h-73.265c-3.774 0-6.793-3.066-6.793-6.842 0-3.777 3.064-6.842 6.793-6.842h73.309c3.775 0 6.794 3.065 6.794 6.842a6.843 6.843 0 0 1-6.838 6.842zm91.47 0H645.32a6.843 6.843 0 0 1 0-13.684h67.492a6.842 6.842 0 0 1 6.838 6.842c-.044 3.776-3.063 6.842-6.838 6.842zm.001 27.237H405.811a6.843 6.843 0 0 1 0-13.684h307.002a6.843 6.843 0 0 1 6.838 6.842c-.045 3.776-3.064 6.842-6.838 6.842zm-138.049 27.234H405.811a6.843 6.843 0 0 1 0-13.684h168.953a6.843 6.843 0 0 1 0 13.684zm138.049 0H602.027a6.843 6.843 0 0 1 0-13.684h110.786a6.843 6.843 0 0 1 6.838 6.842c-.045 3.777-3.064 6.842-6.838 6.842zm-207.717 27.191h-99.285a6.843 6.843 0 0 1 0-13.684h99.285a6.843 6.843 0 0 1 6.838 6.842c-.044 3.821-3.108 6.842-6.838 6.842zm126.105 0h-99.24a6.843 6.843 0 0 1 0-13.684h99.284a6.842 6.842 0 0 1 6.838 6.842c-.044 3.821-3.108 6.842-6.882 6.842zm81.611 0h-57.59a6.843 6.843 0 0 1 0-13.684h57.59a6.842 6.842 0 0 1 6.838 6.842c-.044 3.821-3.063 6.842-6.838 6.842zm-168.553 27.236H405.811a6.843 6.843 0 0 1 0-13.684h138.448a6.842 6.842 0 0 1 6.838 6.842c-.044 3.821-3.063 6.842-6.838 6.842zm168.553-163.368H574.364a6.843 6.843 0 0 1 0-13.684h138.448a6.843 6.843 0 0 1 6.838 6.842c-.044 3.777-3.064 6.842-6.838 6.842z",
    fill: "#E1E4E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M747 198.463a7.507 7.507 0 0 1-7.508 7.508H161.067a7.507 7.507 0 0 1-7.507-7.508c0-16.535 13.403-29.944 29.925-29.944h533.59c16.522 0 29.925 13.409 29.925 29.944z",
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M192.111 187.979c0 3.335-2.72 6.055-6.051 6.055-3.33 0-6.051-2.72-6.051-6.055 0-3.332 2.716-6.052 6.044-6.056 3.352.041 6.058 2.737 6.058 6.056zm23.385-.001c0 3.335-2.72 6.056-6.051 6.056s-6.051-2.721-6.051-6.056c0-3.332 2.716-6.051 6.044-6.055 3.352.04 6.058 2.736 6.058 6.055zm23.384 0c0 3.335-2.72 6.056-6.051 6.056-3.33 0-6.051-2.721-6.051-6.056 0-3.332 2.717-6.051 6.044-6.055 3.391.04 6.058 2.731 6.058 6.055z",
    fill: "#E1E4E5",
    stroke: "#E1E4E5",
    strokeWidth: 2.729
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m245.804 355.473-22.708-22.708 22.708-22.708m68.126 0 22.708 22.708-22.708 22.708m-25.25-56.768-18.928 68.124",
    stroke: "#fff",
    strokeWidth: 16.182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 436.144,
    y1: 715.827,
    x2: 427.187,
    y2: -240.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 557.898,
    y1: 387.203,
    x2: 553.192,
    y2: -97.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg78);
export default __webpack_public_path__ + "static/media/78.6824d902a0b8a88cd255badb1a20e766.svg";
export { ForwardRef as ReactComponent };